module.exports = __webpack_public_path__ + "6bf3ba0ff5aa8c486979e95c574ed7e3.png";